import { HTMLAttributes } from 'react';
import { Scalars } from '@bechtel/types';

export interface PriorityStatBlockComponentProps {
  label: string;
  value: Scalars['String'];
  loading?: boolean;
  priorityCount?: string;
  onStatClick?: () => void;
  onPriorityStatClick?: () => void;
}

export type PriorityStatBlockProps = PriorityStatBlockComponentProps & HTMLAttributes<HTMLDivElement>;
